import { useQuery } from '@tanstack/react-query';
import { selfServiceKeys } from '@/lib/query-keys';
import { selfServiceService } from '@/services/payroll.service';

/**
 * The signed-in employee's own payslips.
 *
 * Nothing here takes an employee id: the server resolves it from the JWT, so
 * the client has no way to ask for anyone else's data.
 */
export function useMyPayslips(params: { page?: number; limit?: number } = {}) {
  const query = useQuery({
    queryKey: selfServiceKeys.payslips(params),
    queryFn: () => selfServiceService.myPayslips(params),
    // A 403 means the login is not linked to an employee — retrying will not help.
    retry: false,
  });
  return {
    payslips: query.data?.data ?? [],
    meta: query.data?.meta,
    isLoading: query.isLoading,
    error: query.error as { response?: { status?: number; data?: { message?: string } } } | null,
  };
}

export function useMyEmployee() {
  const query = useQuery({
    queryKey: selfServiceKeys.employee(),
    queryFn: () => selfServiceService.myEmployee(),
    retry: false,
  });
  return { employee: query.data?.data, isLoading: query.isLoading, isLinked: !query.isError };
}
